<template>
  <div class="ticket-detail-wrapper">
    <display-navigation
      v-show="ticketDetail.ticket"
      path="tickets_list"
      title="门票详情"
    />
    <!-- <display-ticket-cover :value="ticketDetail.logo" /> -->
    <display-swipe :items="slide"/>
    <display-ticket-detail-list
      :ticketId="ticketId"
      :date="ticketDetail.can_book_time"
      :price="price"
      :ticket="ticketDetail.ticket"
      :useStyle="ticketDetail.use_style"
    />
    <!-- <display-description :value="ticketDetail.explain" /> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Dialog } from 'vant';
import { getTicketDetail, getTicketsType } from '../../../api/api-ticket';
// import { createOrder } from '../../../api/api-user';
import DisplayNavigation from '../../../components/DisplayNavigation.vue';
import DisplayTicketCover from '../../../components/DisplayTicketCover.vue';
import DisplayTicketDetailList from '../../../components/DisplayTicketDetailList.vue';
// import DisplayDescription from '../../../components/DisplayDescription.vue';
import DisplaySwipe from '../../../components/DisplaySwipe.vue';


export default {
  name: 'TicketDetailList',
  components: {
    DisplayNavigation,
    DisplayTicketCover,
    DisplaySwipe,
    // DisplayDescription,
    DisplayTicketDetailList,
  },
  data() {
    return {
      loading: false,
      ticketDetail: {},
      showTicketType: false,
      ticketsType: [],
      ticket_type: null,
    };
  },
  computed: {
    
    ...mapGetters(['user']),
    slide(){
      return JSON.parse(sessionStorage.getItem('slideDetail')) 
    },
    ticketId() {
      // eslint-disable-next-line radix
      const id = parseInt(sessionStorage.getItem('ticketId'));

      return this.$route.params.id ? this.$route.params.id : id;
    },
    price() {
      const obj = this.ticketDetail.shape?this.ticketDetail.shape.find(
        item => item.title === '全价票'
      ):{}
      return obj?obj.price:0;
    },
  },
  async mounted() {
    console.log(this.slide)
    // console.log(this.ticketId)
    sessionStorage.setItem('ticketId', this.ticketId);
    try {
      const id = await this.checkTicketId();
      const agentId = sessionStorage.getItem('agentId');
      const detail = await getTicketDetail({ id, agentId });
      this.ticketDetail = detail;
    } catch {
      this.back();
    }
    if (sessionStorage.getItem('isReadHealthNotice') !== '1'&& sessionStorage.getItem('open_health_notice')==1) {
      Dialog.confirm({
        title: '健康管理承诺书',
        message: sessionStorage.getItem('health_notice'),
      }).then(() => {
        // on close
        sessionStorage.setItem('isReadHealthNotice', 1);
      }).catch(()=>{
        this.back();
      })
    }
  },
  methods: {
    async checkTicketId() {
      return new Promise((resolve, reject) =>
        this.ticketId ? resolve(this.ticketId) : reject()
      );
    },
    back() {
      this.$router.push({ name: 'tickets_list' });
    },
    // 选择时间后获取对应的演出场次
    async getTicketType(date) {
      this.ticketsType = await getTicketsType({ id: this.ticketId, date });
      if (this.ticketsType) {
        this.showTicketType = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.ticket-detail-wrapper {
  padding-bottom: 50px;
  .amount-wrapper {
    margin: 46px 0;
    text-align: center;
    .amount {
      font-size: 48px;
    }
    .dollar {
      font-size: 32px;
    }
  }
  .balance {
    padding-right: 12px;
  }
}
</style>
